export default class StopListReason {
  static get NoIngredients () {
    return 'no_ingredients'
  }

  static get ProductSpoiled () {
    return 'product_spoiled'
  }

  static get EquipmentBreakdown () {
    return 'equipment_breakdown'
  }

  static get PowerProblem () {
    return 'power_problem'
  }

  static get Other () {
    return 'other'
  }

  static getName (enumValue) {
    switch (enumValue) {
      case StopListReason.NoIngredients:
        return 'Нет ингридиентов'

      case StopListReason.ProductSpoiled:
        return 'Продукты испортились'

      case StopListReason.EquipmentBreakdown:
        return 'Техника вышла из строя'

      case StopListReason.PowerProblem:
        return 'Проблема с электропитанием'

      case StopListReason.Other:
        return 'Другое'

      default:
        return enumValue
    }
  }

  static getAllVariants () {
    const variants = [
      StopListReason.NoIngredients,
      StopListReason.ProductSpoiled,
      StopListReason.EquipmentBreakdown,
      StopListReason.PowerProblem,
      StopListReason.Other,
    ]

    return variants.map(item => ({
      value: item,
      name: StopListReason.getName(item),
    }))
  }
}
